import { grey, blue, red, green, orange, pink, purple, deepPurple, deepOrange, indigo, lightBlue, cyan, teal, lightGreen, lime, yellow, amber, brown, blueGrey } from '@mui/material/colors'


const colorMap ={
    red: red[400],
    orange: orange[400],
    green: green[400],
    blue: blue[400],
    grey:grey[400],
    pink: pink[400],
    purple: purple[400],
    deepPurple: deepPurple[400],
    deepOrange: deepOrange[400],
    indigo: indigo[400],
    lightBlue: lightBlue[400],
    cyan: cyan[400],
    teal: teal[400],
    lightGreen: lightGreen[400],
    lime: lime[400],
    yellow: yellow[400],
    amber: amber[400],
    brown: brown[400],
    blueGrey: blueGrey[400],
  }

  export {colorMap}